module.exports = __webpack_public_path__ + "static/media/lilly_beyond.735e3c8b.jpg";